export default __webpack_public_path__ + "static/media/ira3.910d4bcf.jpg";